import dayjs from 'dayjs';

export const MIN_DURATION = 30; // 00:30
export const PERSONAL_ACCOUNT_MAX_DURATION = 420; // 07:00
export const PRO_ACCOUNT_MAX_DURATION = 1800; // 30:00
export const maxMinutes = Math.floor(PRO_ACCOUNT_MAX_DURATION / 60);
export const maxSeconds = PRO_ACCOUNT_MAX_DURATION % 60;
export const minMinutes = Math.floor(MIN_DURATION / 60);
export const minSeconds = MIN_DURATION % 60;

export const currentDate = dayjs(0);
export const minDate = currentDate.add(MIN_DURATION, 'seconds');
export const personalAccountMaxDate = currentDate.add(
  PERSONAL_ACCOUNT_MAX_DURATION,
  'seconds'
);
export const proAccountMaxDate = currentDate.add(
  PRO_ACCOUNT_MAX_DURATION,
  'seconds'
);
